import script from "./navigationDates.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationDates.vue?vue&type=script&setup=true&lang=js"

import "./navigationDates.vue?vue&type=style&index=0&id=3a42a3e6&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a42a3e6"]])

export default __exports__